"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _lodash = require("lodash");
var _Icon = require("../../Icon");
require("./style.css");
const handleWheel = e => {
  e.preventDefault();
};
class Input extends _react.default.Component {
  inputRef = /*#__PURE__*/_react.default.createRef();
  componentDidMount() {
    if (this.props.type === "number") {
      this.inputRef.current?.addEventListener("wheel", handleWheel, {
        passive: false
      });
    }
  }
  componentWillUnmount() {
    if (this.props.type === "number") {
      this.inputRef.current?.removeEventListener("wheel", handleWheel);
    }
  }
  render() {
    const {
      label,
      errors,
      name,
      subTitle,
      value,
      isRequired,
      formGroupClassName,
      infoText
    } = this.props;
    let errorClass = errors && (0, _lodash.get)(errors, name) ? 'is-invalid' : 'is-valid';
    let updatedFormGroupClass = formGroupClassName ? `${formGroupClassName} ${errorClass}` : `${errorClass}`;
    const handleRef = el => {
      this.inputRef.current = el;
      if (this.props.innerRef) this.props.innerRef.current = el;
    };
    return /*#__PURE__*/_react.default.createElement(_reactstrap.FormGroup, {
      className: `form-group ${updatedFormGroupClass}`
    }, label && /*#__PURE__*/_react.default.createElement("label", {
      className: "form__label",
      "aria-label": `${label}`
    }, label, isRequired && /*#__PURE__*/_react.default.createElement("span", {
      className: "asterisk"
    }, "*")), subTitle && /*#__PURE__*/_react.default.createElement("p", {
      className: "form__label--subtitle"
    }, subTitle), infoText && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      icon: ['fas', 'info'],
      size: "1x",
      title: infoText,
      className: "form__label--infotext"
    }), /*#__PURE__*/_react.default.createElement(_reactstrap.Input, (0, _extends2.default)({}, this.props, {
      innerRef: handleRef,
      value: value || '',
      "aria-label": `${name}`
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "form--control__error"
    }, errors && (0, _lodash.get)(errors, name)?.message));
  }
}
exports.Input = Input;
Input.propTypes = {
  label: _propTypes.default.string,
  value: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  isRequired: _propTypes.default.bool,
  subTitle: _propTypes.default.string,
  formGroupClassName: _propTypes.default.string
};